import {
  locationLabel,
  formatCardDateTimeRange,
} from '@/lib/utils/event.utils';
import type {
  EventAccessType,
  EventCardDto,
  FeaturedEventProps,
  FeaturedEventResponse,
} from '@/lib/types/events.types';

/** Map a FeaturedEventResponse to the prop shape expected by FeaturedEventCard. */
export function toFeaturedEventProps(dto: FeaturedEventResponse): FeaturedEventProps {
  return {
    title: dto.title,
    // Viewer's local time, matching the other event cards (UX sheet v2).
    dateLabel: dto.startsAt ? formatCardDateTimeRange(dto.startsAt, dto.endsAt) : dto.dateLabel,
    location: dto.location,
    description: dto.description,
    // No stock image when the event has no cover (MYN-343): the card shows a neutral surface instead.
    imageUrl: dto.imageUrl,
  };
}

/**
 * Map an EventCardDto to the prop shape expected by the EventCard grid component.
 * The date label carries the start and end time, so the events page and the
 * dashboard show the same timing for the same event.
 */
export function toEventCardProps(dto: EventCardDto): {
  id: string;
  title: string;
  dateLabel: string;
  location: string;
  imageUrl: string;
  accessType: EventAccessType;
} {
  return {
    id: dto.id,
    title: dto.title,
    dateLabel: dto.startsAt ? formatCardDateTimeRange(dto.startsAt, dto.endsAt) : 'TBD',
    location: locationLabel(dto.locationType),
    imageUrl: dto.coverPhotoUrl ?? '',
    accessType: dto.accessType,
  };
}
